import { APP_INITIALIZER, ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, Router, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from './shared/interceptors/http.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';
import * as Sentry from "@sentry/angular";
import { ChunkReloadErrorHandler } from './shared/error-handler/chunk-reload-error-handler';
import { PreconnectService } from './shared/preconnect.service';
import { MODAL_CONTENT_COMPONENT } from './shared/modal-content/modal-content.token';
import { ModalContentComponent } from './shared/modal-content/modal-content.component';
// import * as Sentry from "@sentry/angular";

function initializePreconnects(preconnectService: PreconnectService) {
  return () => preconnectService.initializePreconnects();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideClientHydration(withIncrementalHydration()),
    provideAnimations(),
    provideNativeDateAdapter(),
    provideHttpClient(
      withFetch(),
      withInterceptors([httpInterceptor])
    ),
    {
      // Wraps Sentry's ErrorHandler and adds a one-shot hard reload when a stale
      // post-deploy chunk fails to load (NG0750 / ChunkLoadError / module MIME).
      provide: ErrorHandler,
      useClass: ChunkReloadErrorHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializePreconnects,
      deps: [PreconnectService],
      multi: true
    },
    // Supplies the modal host component to ModalContentService via DI so the
    // service doesn't statically import it — breaks a circular dependency.
    { provide: MODAL_CONTENT_COMPONENT, useValue: ModalContentComponent },
  ]
};
